// @flow

import type {VideoModel, VideoPlaylistModel} from 'docs/data';

export const getTopicID = (video: VideoModel) => {
  // TODO (playlist-docs): string manipulation to get id is bad, but
  // updating this requires updating the video data model
  return video.id.substring(0, video.id.lastIndexOf('-'));
};

export const videoMatchesTopicFromURL = (video: VideoModel, topic: ?string) => {
  const topicID = getTopicID(video);
  const idParts = topicID.split('/');
  // This allows "video=authentication" to match "foundations/authentication".
  // This allows for cleaner URLs, since foundations/authentication url encodes
  // to foundations%2Fauthentication which looks bad.
  // TODO (playlist-docs): string manipulation to match these IDs is bad.
  // We should update the data model to have a "short id" without slashes.
  return topicID === topic || idParts[1] === topic;
};

// Helper for extracting the videos from a VideoPlaylistModel based on
// the current user's preferences. It accepts the playlist and the getPref
// method from the usePrefs hook so that it can filter all videos in a chapter
// to only the list of videos where either the prefs match or the default
// video for the chapter is used.
export const prefVideosForPlaylist = (
  playlist: VideoPlaylistModel,
  prefs: {
    lang: string | null,
    client: string | null,
    platform: string | null,
  },
): Array<VideoModel> => {
  return playlist.chapters.map((chapter) => {
    const matches = chapter.videos.map((video) => {
      const hits = ['platform', 'client', 'lang'].filter(
        (pref) => video.prefs[pref] && video.prefs[pref] === prefs[pref],
      ).length;

      return {video, hits};
    });

    if (matches.length > 0) {
      return matches.sort((a, b) => b.hits - a.hits)[0].video;
    } else {
      // TODO (playlist-docs): In the case we do not have a video that satisifies the users
      // prefs, we should indicate to the user somewhere on the page that we were
      // not able to.
      return chapter.defaultVideo;
    }
  });
};

// Helper for converting from an integer seconds duration to a string.
// Note: Doesn't yet support hours.
// E.g.
//     convertTimeToString(5) //> "00:05"
//     convertTimeToString(50) //> "00:50"
//     convertTimeToString(500) //> "08:20"
//     convertTimeToString(3601) //> "60:01"
export function convertTimeToString(time: ?number) {
  if (time === null || time === undefined) {
    return null;
  }
  const minute = Math.floor(time / 60);
  const second = time - minute * 60;

  if (second < 10) {
    return `${minute.toString()}:0${second.toString()}`;
  }

  return `${minute.toString()}:${second.toString()}`;
}

export function polarToCartesian(
  centerX: number,
  centerY: number,
  radius: number,
  angleInDegrees: number,
) {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
}

// If there are 15 seconds left in a video, we consider the
// video "watched".
export const SECONDS_LEFT_TO_CONSIDER_WATCHED = 15;
